import { Component, ChangeDetectorRef } from '@angular/core';
import { NavController, Events, App } from 'ionic-angular';
import { OrderHistoryCommon } from './order-history.common';
import { PageBase } from '../../../../core/page-base';
import { UserData } from '../../../../providers/user-data'; 
import { AppSettings } from '../../../../config/app-settings';
import { PageRef } from '../../../../core/core.module';


@Component({
	selector: 'page-order-history',
	templateUrl: 'order-history.html'
})

export class OrderHistoryPage extends PageBase{
	public submitted = false;
	public formMsg: any;
	
	constructor(
		public events: Events,
		public app: App,
		public cd: ChangeDetectorRef,		
		public common: OrderHistoryCommon,
		public nav: NavController,
    	public userData: UserData,
    	public settings: AppSettings,
    	public pageRef: PageRef,
    ) {	
    	super(settings, events, nav, userData);
		console.log("Loading Order History Mobile");
	}

	ionViewDidEnter() {
		this.app.setTitle('Profile');
	}

	ngAfterViewInit() {
		this.common.commonMethod();
	}

}


// WEBPACK FOOTER //
// ./src/modules/account/pages/order-history/order-history.ts